import { usePeopleManagementApi } from 'infrastructure/api';
import { ComplianceDocumentNamesResponce } from 'domain/shared/compliance';

const useComplianceRegistryService = () => {
  const { sendPostRequest } = usePeopleManagementApi();

  const getComplianceDocumentNames = async (asOfDate: string | Date): Promise<ComplianceDocumentNamesResponce[]> => {
    const response = await sendPostRequest(`/policies/types`, { asOfDate });
    const result = await response.json();
    return result;
  };

  return {
    getComplianceDocumentNames,
  };
};

export default useComplianceRegistryService;
